import GET_WHOLESALE_RETAIL_SEASONS from './getWholesaleRetailBuyingSessionGroups.graphql'

export default GET_WHOLESALE_RETAIL_SEASONS
